// extracted by mini-css-extract-plugin
module.exports = {"colorRed":"#ed4c47","link":"link_link__dRY3r"};